import React from 'react'
import Smartview from 'widgets/smartviews/Smartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as Displays from 'support/displays'
import SmartviewContentSection from 'widgets/smartviews/partials/SmartviewContentSection'
import SmartviewTextGroup from 'widgets/smartviews/partials/SmartviewTextGroup'
import SmartviewText from 'widgets/smartviews/partials/SmartviewText'
import { Model, useValue, WhenModelValue } from '@morningtrain/react-resources'
import { StaticFilter } from '@morningtrain/react-filters'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'

export default function PersonalSalaryOverviewSmartview () {
  const salaryPeriodId = useValue('id')

  return (
    <Translator namespace='smartviews.user_salary_overview'>
      <Smartview header={<Translation name='titles.personal_overview'/>}>

        <Model resourceName='salary.salary_period' operationName='personal'>
          <StaticFilter name='salary_period' value={salaryPeriodId}/>

          <SmartviewContentSection>

            <SmartviewTextGroup highlight>
              <SmartviewText
                label={(
                  <>
                    <span><Translation name='hours_worked'/></span>
                    <Displays.Duration name='hours_worked'/>
                  </>
                )}
                textSize='text-xs'
              >
                <div className='flex justify-between'>
                  <span><Translation name='hours_admin_worked'/></span>
                  <Displays.Duration name='hours_admin_worked'/>
                </div>
                <div className='flex justify-between'>
                  <span><Translation name='in_primary_department'/></span>
                  <Displays.Duration name='hours_worked_in_primary_department'/>
                </div>
                <div className='flex justify-between'>
                  <span><Translation name='in_this_department'/></span>
                  <Displays.Duration name='hours_worked_in_this_department'/>
                </div>
                <div className='flex justify-between'>
                  <span><Translation name='in_other_departments'/></span>
                  <Displays.Duration name='hours_worked_in_other_departments'/>
                </div>
              </SmartviewText>
              <SmartviewText
                label={(
                  <>
                    <span><Translation name='shifts_count'/></span>
                    <Displays.Integer
                      name='shifts_count'
                    />
                  </>
                )}
                textSize='text-xs'
              >
                <div className='flex justify-between'>
                  <span><Translation name='in_primary_department'/></span>
                  <Displays.Integer name='shifts_count_in_primary_department'/>
                </div>
                <div className='flex justify-between'>
                  <span><Translation name='in_this_department'/></span>
                  <Displays.Integer name='shifts_count_in_this_department'/>
                </div>
                <div className='flex justify-between'>
                  <span><Translation name='in_other_departments'/></span>
                  <Displays.Integer name='shifts_count_in_other_departments'/>
                </div>
                <div className='flex justify-between'>
                  <span><Translation name='expected_employee_food_cost'/></span>
                  <Displays.Currency name='expected_employee_food_cost'/>
                </div>
              </SmartviewText>
              <SmartviewText
                label={(
                  <>
                    <span><Translation name='planned_shifts'/></span>
                    <Displays.Duration
                      name='planned_shifts'
                    />
                  </>
                )} textSize='text-xs'
              >
                <div className='flex justify-between'>
                  <span><Translation name='in_primary_department'/></span>
                  <Displays.Duration name='planned_shifts_in_primary_department'/>
                </div>
                <div className='flex justify-between'>
                  <span><Translation name='in_this_department'/></span>
                  <Displays.Duration name='planned_shifts_in_this_department'/>
                </div>
                <div className='flex justify-between'>
                  <span><Translation name='in_other_departments'/></span>
                  <Displays.Duration name='planned_shifts_in_other_departments'/>
                </div>
              </SmartviewText>
              <WhenDeviceNotAuthorized>
                <SmartviewText
                  label={(
                    <>
                      <span><Translation name='salary_amount'/></span>
                      <Displays.Currency
                        name='amount'
                      />
                    </>
                  )} textSize='text-xs'
                >
                  <WhenModelValue name='salary_type' condition='hourly'>
                    <div className='flex justify-between'>
                      <span><Translation name='hourly_wage'/></span>
                      <Displays.Currency name='wage'/>
                    </div>
                  </WhenModelValue>
                </SmartviewText>
              </WhenDeviceNotAuthorized>
            </SmartviewTextGroup>

          </SmartviewContentSection>

        </Model>
      </Smartview>
    </Translator>
  )
}
